import React from 'react';
import Breadcrumb from '../common/breadcrumb';
import Tabset from './tabset-editar-questao';

const EditarQuestoes = () => {
  return (
    <>
      <Breadcrumb title="Editar Questão" parent="Categorias" />
      <div className="container-fluid">
        <div className="card">
          <div className="card-header">
            <h5>Editar Questão</h5>
          </div>
          <div className="card-body">
            <Tabset />
          </div>
        </div>
      </div>
    </>
  );
};

export default EditarQuestoes;
